<template>
    <div class="not-found">
        <div class="not-found__content">
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>Sorry, the page you're looking for doesn't exist.</p>
            <router-link to="/" class="home-button">Return to Home</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
}
</script>

<style scoped>
.not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
    background-image: linear-gradient(to right, #002655, #89c2fc);
    color: white;
    text-align: center;
    padding: 20px;
}

.not-found__content h1 {
    font-size: 6rem;
    margin: 0;
    font-weight: bold;
}

.not-found__content h2 {
    font-size: 2rem;
    margin: 10px 0;
}

.not-found__content p {
    font-size: 1.2rem;
    margin: 20px 0;
}

.home-button {
    display: inline-block;
    padding: 15px 30px;
    background-color: #8d0808;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    font-size: 1.1rem;
    transition: background-color 0.3s ease;
}

.home-button:hover {
    background-color: #0056b3;
}

@media (max-width: 768px) {
    .not-found__content h1 {
        font-size: 4rem;
    }
    
    .not-found__content h2 {
        font-size: 1.5rem;
    }
}
</style>
